import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { withFormsy } from "formsy-react";

import Cleave from "cleave.js/react";

class CurrencyInput extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange = (event) => {
    const input = event.target.value;
    this.props.setValue(input.replace(/[,$]/g, ""));
  };

  render() {
    const { name, placeholder, label, required, readOnly, disabled } =
      this.props;

    const fieldLabel = required ? `${label} *` : label;

    return (
      <div className="form-group row">
        <label
          className="control-label"
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
        <Cleave
          readOnly={readOnly}
          required={required}
          formNoValidate
          className="form-control"
          options={{ numeral: true, prefix: "$" }}
          name={name.replace(/_/g, " ")}
          label={label}
          placeholder={placeholder}
          value={this.props.getValue()}
          disabled={disabled}
          onChange={
            this.props.onChange ? this.props.onChange : this.handleChange
          }
        />
      </div>
    );
  }
}

CurrencyInput.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  required: PropTypes.bool,
  readOnly: PropTypes.bool
};

export default withFormsy(CurrencyInput);
